import { File, Settings, Users, Home } from 'react-feather'
import { Btc } from 'react-cryptocoins'


export default [
  {
    id: 'home',
    title: 'Home',
    icon:  <Home size={20} />,
    navLink: '/home'
  },
  {
    id: 'bbcn',
    title: 'Token BBCN',
    icon: <Btc size={20} />,
    navLink: '/bbcn'
  },
  {
    id: 'contracts',
    title: 'Deposit',
    icon: <Btc size={20} />,
    navLink: '/contracts'
  }, 
  {
    id: 'liquidations',
    title: 'Withdrawal',
    icon: <Btc size={20} />,
    navLink: '/liquidations'
  }, 
  {
    id: 'contract',
    title: 'Reports',
    icon: <File size={20} />,
    navLink: '/contract'
  },  
  {
    id: 'ambassadors',
    title: 'Ambassadors',
    icon: <Users size={20} />,
    navLink: '/ambassadors'
  },
  {
    id: 'settings',
    title: 'Settings',
    icon: <Settings size={20} />,
    navLink: '/settings'
  }
]
